import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  image: string;
  date: string;
  readTime: string;
  tags: string[];
  featured?: boolean;
}

export default function ArticleCard({ slug, title, excerpt, image, date, readTime, tags, featured = false }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${slug}`}
      className={`group cursor-pointer bg-background-100 rounded-xl overflow-hidden border border-background-200/50 hover:border-primary-500/20 transition-all duration-300 ${
        featured ? 'lg:col-span-2 lg:flex' : ''
      }`}
    >
      <div className={`overflow-hidden ${featured ? 'lg:w-2/5 flex-shrink-0' : ''}`}>
        <img
          src={image}
          alt={title}
          className={`w-full object-cover transition-transform duration-500 group-hover:scale-105 ${
            featured ? 'h-64 lg:h-full' : 'h-48'
          }`}
        />
      </div>
      <div className={`p-5 ${featured ? 'lg:w-3/5 lg:flex lg:flex-col lg:justify-center' : ''}`}>
        <div className="flex items-center gap-3 text-xs text-foreground-400 mb-2">
          <span>{date}</span>
          <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
          <span>{readTime}</span>
        </div>
        <h3 className={`font-heading font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors duration-200 ${
          featured ? 'text-xl md:text-2xl' : 'text-base'
        }`}>
          {title}
        </h3>
        <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-2">
          {excerpt}
        </p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {tags.map((tag) => (
            <span
              key={tag}
              className="text-xs px-2.5 py-1 rounded-full bg-secondary-100/30 text-secondary-400 border border-secondary-200/20 whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}